import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import localforage from 'localforage'
import { PropsWithChildren, useState } from 'react'

import { createQueryClient } from '@/integrations/react-query'

export const QueryProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(() => createQueryClient())
  const [asyncPersister] = useState(() =>
    createAsyncStoragePersister({
      storage: localforage,
    }),
  )

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: asyncPersister }}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  )
}
